import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalexpercommentbacktbn from './Modalexpercommentbacktbn';
import { URL,api } from '../../api';

export default class Commentbnlist extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   expert_id:'',
   commentbn:[],
   url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
   
}


//this.handleSubmit = this.handleSubmit.bind(this);

this.toggle = this.toggle.bind(this);
this.list = this.list.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()
;  this.props.selectex();
}


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       expert_id:this.props.expert_id,
         })
      setTimeout(() => {
       
        api.get('registercon/selectArticlespfbnwhereid/'+this.props.id_emp+'/'+this.props.id_articlepsf, )
        .then(res => {
          console.log(res);
       
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }

  list() {
 
      setTimeout(() => {
        api.get('registercon/selectArticlespfbnwhereid/'+this.props.id_emp+'/'+this.props.id_articlepsf, )
        .then(res => {
          console.log(res);
          this.setState({ commentbn: res.data})
        }) 

      }, 0);

  }



    render() {
        

        return (
            <>
           <MDBTable small>
      <MDBTableHead color="blue-grey lighten-3" textWhite>
        <tr>
          <th>ลำดับ</th>
          <th>ไฟล์ผลงาน</th>
          <th>วันที่ส่งผลงาน</th>
          <th>ไฟล์ข้อเสนอแนะ</th>
          <th>วันที่ส่งกลับ</th>
          <th>สถานะ ผ่าน/ปรับแก้ไข</th>
          <th>การส่งกลับ</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
                      {this.state.commentbn.map((commentbn,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        {/* <td>{commentbn.fileword}</td> */}
                        <td>{commentbn.send_uploadewordbn !== null ? <>
                          <tr>
                              <th> <a href={`${this.state.url+commentbn.send_uploadewordbn}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF01</p> </a></th>
                              <th> <a href={`${this.state.url+commentbn.send_uploadewordbn2}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF02</p> </a></th>
                              <th> <a href={`${this.state.url+commentbn.send_uploadewordbn3}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF03</p> </a></th>
                              <th> <a href={`${this.state.url+commentbn.send_uploadewordbn4}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word PSF04</p> </a></th>
                          </tr>
                          <tr>
                              <th>  <a href={`${this.state.url+commentbn.send_uploadepdfbn}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF01</p> </a> </th>
                              <th>  <a href={`${this.state.url+commentbn.send_uploadepdfbn2}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF02</p> </a></th>
                              <th>  <a href={`${this.state.url+commentbn.send_uploadepdfbn3}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF03</p> </a></th>
                              <th>  <a href={`${this.state.url+commentbn.send_uploadepdfbn4}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf PSF04</p> </a></th>
                          </tr>
                            {/* <a href={`${this.state.url+commentbn.send_uploadewordbn}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .word</p> </a>
                            <a href={`${this.state.url+commentbn.send_uploadepdfbn}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-word" /> ไฟล์บทความ .pdf</p> </a> */}
                           </>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentbn.dateaddbn}</td>

                        {/* <td>{commentbn.filewordcomment_bn !== null ? <>{commentbn.filewordcomment_bn}</>:<><MDBIcon far icon="hourglass" /></>}</td> */}
                        <td>{commentbn.send_uploadcommentepdfbn !== null  ? <>
                            <a href={`${this.state.url+commentbn.send_uploadcommentepdfbn}`} target="_blank"><p className="green-text"><MDBIcon far icon="file-word" /> ไฟล์ข้อเสนอแนะ .pdf</p> </a>
                            
                           </>:<>
                           {commentbn.statusbn ==='2'?<>-</>:<> <MDBIcon far icon="hourglass" /></>}
                          
                           </>}</td>

                        <td>{ commentbn.date_senbackbn !== null ?<>{commentbn.date_senbackbn}</>:<><MDBIcon far icon="hourglass" /></>}</td>

                        <td>{commentbn.statusbn==='2'?<>ผ่าน</>:<>
                               {commentbn.statusbn==='0'?<>ปรับแก้ไข</>:<><MDBIcon far icon="hourglass" /> รอพิจารณา</>}
                            </>}
                        </td>

                        <td>
                          {commentbn.statusbn ==='2' || commentbn.statusbn ==='0'  ?<>แจ้งกลับแล้ว</>:<>
                          {commentbn.statusbn ==='3' ?<>ส่งกลับแล้ว</>:<><Modalexpercommentbacktbn id_articlepsf={commentbn.id_articlepsf} id_empbn={commentbn.id_empbn} idarticlebn={commentbn.idarticlebn} nameuserbn={commentbn.nameuserbn} send_uploadewordbn={commentbn.send_uploadewordbn} send_uploadewordbn2={commentbn.send_uploadewordbn2} send_uploadewordbn3={commentbn.send_uploadewordbn3} send_uploadewordbn4={commentbn.send_uploadewordbn4}  send_uploadepdfbn={commentbn.send_uploadepdfbn} send_uploadepdfbn2={commentbn.send_uploadepdfbn2} send_uploadepdfbn3={commentbn.send_uploadepdfbn3} send_uploadepdfbn4={commentbn.send_uploadepdfbn4} list={this.list}  /></> }
                               
                          </>}
                        
                        
                        {}
                            
                            </td>
                        </tr>
                      )}
       
      </MDBTableBody>
    </MDBTable>
           
          </>
          
        )
    }
}


